import * as React from 'react';
import { StarryUIIcon } from '../components/StarryUIIcon';

export const ChevronRight = ({ color = 'currentColor', ...icon }: image.IStarryUIIcon) => (
    <StarryUIIcon {...icon}>
        <path
            d="M16.3334 12C16.3282 12.1452 16.2635 12.2892 16.139 12.4003L10.8012 17.1596C10.5421 17.3912 10.1213 17.3912 9.86152 17.1596C9.60174 16.9286 9.60174 16.5534 9.86152 16.3218L14.7087 12L9.86152 7.67816C9.60174 7.44653 9.60174 7.0713 9.86152 6.84036C10.1213 6.60872 10.5421 6.60872 10.8012 6.84036L16.139 11.5997C16.2635 11.7107 16.3282 11.8547 16.3334 12Z"
            fill={color}
        />
    </StarryUIIcon>
);
